<template>
  <EchartsLayout :option="option"></EchartsLayout>
</template>

<script>
import {
  getCacheOrRequest,
  replaceZhenAndJieDao,
  echatsTextFontSize,
} from "@/utils/index.js";
import ComponentBase from "@/components/mixin/ComponentBase.vue";
import EchartsLayout from "@/components/common/EchartsLayout.vue";

export default {
  mixins: [ComponentBase],
  components: {
    EchartsLayout,
  },
  data() {
    return {
      option: null,
    };
  },
  methods: {
    get_component_data() {
      getCacheOrRequest.call(this, {
        method: "get",
        url: `/nh/getLocalElderHousehold`,
        success: (response) => {
          let arr = [];
          response.data &&
            response.data.data &&
            response.data.data.map &&
            response.data.data.map((item) => {
              arr.push([item.divisionName, item.number]);
            });

          arr = replaceZhenAndJieDao(arr);

          // 更新配置
          this.option = {
            grid: {
              top: 150,
              left: 200,
              right: 0,
            },
            series: [
              {
                showItemStyle: true,
                itemStyle: {
                  color: {
                    colorStops: [
                      { color: "RGBA(255, 137, 4, 1)", offset: 1 },
                      { color: "RGBA(255, 208, 42, 1)", offset: 0 },
                    ],
                    globalCoord: false,
                    type: "linear",
                    x: 0,
                    x2: 0,
                    y: 0,
                    y2: 1,
                  },
                  borderRadius: 50,
                },
                name: "社区养老场所",
                type: "bar",
                barWidth: 100,
                markPoint: {
                  data: [
                    { type: "max", name: "最大值" },
                    { type: "min", name: "最小值" },
                  ],
                  label: {
                    ...echatsTextFontSize,
                  },
                },
              },
            ],
            title: {
              text: "单位：家",
              ...echatsTextFontSize,
            },
            xAxis: {
              type: "category",
              axisLabel: {
                ...echatsTextFontSize,
              },
            },
            yAxis: {
              axisLabel: {
                ...echatsTextFontSize,
              },
            },
            dataset: {
              source: [["镇街", "本地户籍长者数量"], ...arr],
            },
          };
        },
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
